import { BloomError } from '@jane/bloom/utils/errors/bloomError';

interface InitArgs {
  originalError?: unknown;
  request: {
    url: URL;
    verb: string;
  };
  response: {
    body: string;
    status: number;
  };
}

export class FetchError extends BloomError {
  /** Raw upstream response body, for callers that re-surface it. */
  body: string;

  /** Status of the upstream response, for callers that re-surface it. */
  status: number;

  constructor({ originalError, request, response }: InitArgs) {
    const { url, verb } = request;
    const { status } = response;

    const message = `${status} ${verb} ${url}`;
    super({
      context: {
        request,
        response,
      },
      fingerprint: `${verb}::${request.url.pathname}`,
      message,
      originalError,
    });
    this.name = 'FetchError';
    this.body = response.body;
    this.status = status;
  }
}
